<template>
  <div class="pr-md-24">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'subcategory-index' })"
      >
        <v-icon left>
          arrow_back
        </v-icon>
        Back
      </v-btn>
    </div>
    <v-form
      v-model="valid"
      ref="form"
      class=""
      lazy-validation
      @submit.prevent="createSubcategory"
    >
      <v-card elevation="0" outlined class="pr-md-24 pl-md-4 mb-10 pt-4">
        <v-container>
          <v-row class="mb-2">
            <v-col cols="12" md="6">
              <v-text-field
                :counter="35"
                outlined
                label="Name"
                v-model="subcategory.name"
                :rules="nameRules"
              ></v-text-field>
              <v-autocomplete
                v-model="subcategory.productCategoryId"
                :items="categories"
                outlined
                label="Select Category"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
              <v-autocomplete
                v-model="subcategory.productSubCategoryTypeId"
                :items="subcategoryTypes"
                outlined
                label="Select Subcategory Type"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
              <v-textarea
                :counter="200"
                outlined
                label="Description"
                :rules="descriptionRules"
                v-model="subcategory.description"
                required
              ></v-textarea>
              <div class="text-left">
                <v-btn type="submit" color="accent" class="mx-0">Create</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      valid: false,
      subcategory: {
        name: "",
        description: "",
        productCategoryId: "",
        productSubCategoryTypeId: ""
      },
      nameRules: [
        v => !!v || "Name is required",
        v => v.length >= 3 || "Name must be at least 3 characters",
        v => v.length <= 50 || "Name must be less than than 35 characters"
      ],
      descriptionRules: [
        v => !!v || "Description is required",
        v => v.length >= 10 || "Description must be at least 8 digits",
        v => v.length <= 200 || "Description must be less than than 20 digits"
      ]
    };
  },
  mounted() {
    this.$store.dispatch("categories/LOAD_CATEGORIES", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("subcategorytypes/LOAD_SUBCATEGORY_TYPES", {
      from: 0,
      to: 0
    });
  },
  computed: {
    ...mapState({
      categories: state => state.categories.categories,
      subcategoryTypes: state => state.subcategorytypes.subcategoryTypes
    })
  },
  methods: {
    async createSubcategory() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Adding Subcategory...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch(
          "subcategories/CREATE_SUBCATEGORY",
          this.subcategory
        );
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Product subcategory brand has been added",
          icon: "info"
        });
      }
    }
  }
};
</script>
